// Local translations
export const T = {
  en_GB: {
    buttonLabel: "Button Label",
    buttonLabelPlaceholder: "Learn more",
    buttonLabelHint:
      "Text shown on the button that opens the popup. Name what it opens, like Learn more. Buttons that write something say Save or Add, so avoid those words here.",
    title: "Popup Title",
    titlePlaceholder: "About this question",
    content: "Content",
    contentPlaceholder: "Type # followed by space for heading, **bold**, *italic*, or use toolbar",
    contentHint: "Markdown content shown inside the popup (same formatting as Text Block)",
  },
  nb_NO: {
    buttonLabel: "Knappetekst",
    buttonLabelPlaceholder: "Les mer",
    buttonLabelHint:
      "Tekst som vises på knappen som åpner popup-vinduet. Navngi det den åpner, for eksempel Les mer. Knapper som lagrer noe heter Lagre eller Legg til, så unngå de ordene her.",
    title: "Popup-tittel",
    titlePlaceholder: "Om dette spørsmålet",
    content: "Innhold",
    contentPlaceholder:
      "Skriv # etterfulgt av mellomrom for overskrift, **fet**, *kursiv*, eller bruk verktøylinjen",
    contentHint: "Markdown-innhold som vises i popup-vinduet (samme formatering som Tekstblokk)",
  },
} as const;
